import axios from 'axios';
import { setRecoil } from "recoil-nexus";
import logoutServices from './logout.services';
import { AppEnv  } from '../environment';
import { ErrorState } from '../Recoil-State';

axios.interceptors.response.use(function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if( error && error.response && error.response.status && error.response.status === 401 ) {
      // Access token is expired, signed out application
      
      if( AppEnv === 'local') {
        let message = 'Token has been expire please update token in environment.js'
        console.error(message);
        setRecoil(ErrorState, message)
      } else {
        logoutServices.logout();
      }
    } else {
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  });